import React, { useState, useEffect } from "react";
import "../css/Home.css";
import { FaArrowRightLong } from "react-icons/fa6";
import GetInTouch from "./GetInTouch";
import { HiX } from "react-icons/hi";

const slides = [
  {
    title: "Cooling expertise you can trust",
    desc:
      "Air conditioning emergencies can happen at any time. Our Cool Care Emergency Service is available 24/7.",
    btnText: "BOOK NOW",
    img: "/AcRepair.jpg",
  },
  {
    title: "Expert AC Maintenance Services",
    desc:
      "Prevent breakdowns with our reliable AC inspections. Book your annual maintenance today.",
    btnText: "BOOK NOW",
    img: "/Ac2.jpg",
  },
  {
    title: "Energy-Efficient Solutions",
    desc:
      "Upgrade to an energy-saving unit and cut down on power bills. Talk to our experts.",
    btnText: "BOOK NOW",
    img: "/Ac3.jpg",
  },
];

const Hero = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  // Auto-slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative w-full">
      {/* Right background */}
      <div
        className="absolute top-0 right-0 w-[30%] h-full z-10 bg-orange-600 bg-cover bg-center hidden lg:block"
        style={{ backgroundImage: `url("/HeroRight.svg")` }}
      ></div>

      {/* Hero Section */}
      <section className="flex w-full h-[50vh] sm:min-h-screen relative z-20">
        <div className="w-full lg:w-[80vw] mt-32 bg-[#0D1B39] text-white relative z-30 overflow-hidden">
          <div className="relative h-full w-full">
            {slides.map((slide, i) => (
              <div
                key={i}
                className={`absolute top-0 left-0 w-full h-full transition-opacity duration-700 ease-in-out ${
                  i === activeIndex ? "opacity-100 z-20" : "opacity-0 z-10"
                }`}
                style={{
                  backgroundImage: `url("${slide.img}")`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <div className="bg-black bg-opacity-50 w-full h-full flex items-center px-4 sm:px-10 lg:px-24 py-8">
                  <div className="max-w-xl">
                    <p className="text-orange-500 font-semibold text-sm sm:text-base">
                      Repairing Services
                    </p>
                    <h2 className="text-xl sm:text-4xl lg:text-5xl font-bold mb-2 sm:mb-4">
                      {slide.title}
                    </h2>
                    <p className="mb-4 sm:mb-6 text-sm sm:text-lg">{slide.desc}</p>
                    <button
                      className="bg-orange-500 px-4 py-2 sm:px-6 sm:py-3 font-semibold text-white rounded-lg"
                      onClick={openModal}
                    >
                      <span className="flex items-center gap-2 text-sm sm:text-base">
                        {slide.btnText} <FaArrowRightLong />
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Marquee */}
      <div className="w-full h-20 sm:h-24 flex items-center overflow-hidden relative z-20">
        <div
          className="absolute right-0 top-0 w-[30%] h-full bg-orange-600 z-30 bg-cover bg-center hidden lg:block"
          style={{ backgroundImage: `url("/HeroRight.svg")` }}
        ></div>

       <div className="marquee marquee-wrapper whitespace-nowrap text-lg sm:text-3xl font-semibold flex z-10 pl-10">
  <span className="text-red-500 mx-4">✨ AC Repair & Service</span>
  <span className="text-blue-600 mx-4">✨ HVAC Repair & Service</span>
  <span className="text-green-500 mx-4">✨ AC Installation and Deinstallation</span>
  <span className="text-purple-600 mx-4">✨ AC Work for Industrial, Commercial, Residential & Office</span>
  <span className="text-yellow-500 mx-4">✨ Old AC Sale and Purchase</span>
  <span className="text-pink-500 mx-4">✨ AC on Rent</span>
</div>

      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[100]">
          <div className="bg-white w-full max-w-3xl rounded-lg relative overflow-y-auto max-h-[90vh]">
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-2xl text-orange-500 hover:text-red-500"
            >
              <HiX />
            </button>
            <GetInTouch showModal={showModal} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Hero;
